import React, { useState, useEffect, useRef } from 'react';
import { Button, Spin, Popover, message } from 'antd';
import { PrinterOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import MessagesTop from '../../component/messagesTop/messagesTop';
import { useParams } from 'react-router-dom';
import tag1 from '../../public/img/tag/tag1.png';
import tag2 from '../../public/img/tag/tag2.png';
import './studentApplyJobDetail.css'
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import $ from 'jquery';
import StdApplyJobModal from './stdApplyJobModal';
import NewMessage from '../../component/newMessage/newMessage';
import { studentCheckLogin } from '../newMain/studentMain';
import AttachDocumentModal from './attachDocumentModal';
import { ContextHandler } from '../../public/js/contextHandler';

import approveImg from '../../public/img/newMain/Approve.png';
import rejectImg from '../../public/img/newMain/Reject.png';
import attachDocumentImg from '../../public/img/buttonImg/attachDocument.png';
import submitApplicationImg from '../../public/img/buttonImg/submitApplication.png';
import CompanyLogo from '../../public/img/company/companyLogo.png';
import DeclineImg from '../../public/img/newMain/Decline.png';
import MessageRejected from './messageRejected';
import MessageRequest from './messageRequest';

const StudentApplyJobDetail = () => {

    const { jobApplId } = useParams();
    const [jobApplModel, setJobApplModel] = useState({})
    const messageRef = useRef();
    const newMessageRef = useRef();
    const MessageReasonRef = useRef();
    const declineMessageRef = useRef();
    const requestMessageRef = useRef();
    const [isStdApplyJobModal, setIsStdApplyJobModal] = useState(false);
    const attachMessageRef = useRef();
    const submitMessageRef = useRef();
    const [isLoad, setIsLoad] = useState(false);
    const [isAttachDocumentModal, setIsAttachDocumentModal] = useState(false)

    const [spinInfo, setSpinInfo] = useState("");

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        searchById(jobApplId)
    }, []);

    const searchById = (jobApplId) => {
        let model = {
            jobApplId: jobApplId,
            cohortYear: Config.cohort?.cohortYear
        }
        Base.callBackApi("jobAppl/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setJobApplModel(model);
                let jobDesc = model?.jobDesc?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#jobDesc").empty().append(jobDesc);
                let jobRequirement = model?.jobRequirement?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#jobRequirement").empty().append(jobRequirement);
                let companyProfile = model?.companyProfile?.replace(/\\/g, "/")?.replace(/&nbsp;/g, ' ');
                $("#companyProfile").empty().append(companyProfile);
                if ((model.jobApplStatus === 'REQUEST_DOCUMENT') && model.eventRemark) {
                    errFrameShow("From Industrial Partner: " + model.eventRemark)
                } else {
                    messageRef.current.setIsShow(false)
                }
                if ((model.jobApplStatus === 'REJECTED') && model.rejectedRemark) {
                    errFrameShow("MC Rejected Reason: " + model.rejectedRemark)
                } else {
                    messageRef.current.setIsShow(false)
                }
            } else {
                message.error(data.msg)
            }
        })
    }

    const errFrameShow = (msg) => {
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
    }

    const newMessageDone = () => {
        newMessageRef.current.setIsShow(false)
        searchById(jobApplId)
    }

    const reapply = () => {
        setIsStdApplyJobModal(true)
    }

    const stdApplyJobClose = (flag, jobApplId, applyFlag) => {
        if (flag) {
            setIsStdApplyJobModal(false);
            if (applyFlag === 'apply') {
                newErrFrameShow("You've successfully reapplied to this position. Please wait for your module convener to approve your application to verify prerequisites.")
            } else if (applyFlag === 'draft') {
                newErrFrameShow("You have successfully saved your draft.")
            }
        } else {
            setIsStdApplyJobModal(false);
        }
    }

    const newErrFrameShow = (msg) => {
        newMessageRef.current.setContent(msg)
        newMessageRef.current.setIsShow(true)
    }

    const downloadFile = (item, flag) => {
        if (!Base.stopClick()) {
            return;
        }
        if (flag) {
            item.url = Config.studentFiles + item.path;
        } else {
            item.url = Config.jobApplFiles + item.path;
        }
        Base.downloadFile(item.url + '?' + Config.sasToken, item.name)
        // if (item.lastModified) {
        //     return;
        // }
        // if (flag) {
        //     item.code = "STUDENT_PATH";
        // } else {
        //     item.code = "JOB_APPL_PATH";
        // }
        // fetch(Config.apiDownloadServer + "downloadFile/downloadFile", {
        //     method: 'POST',
        //     body: JSON.stringify(item),
        //     headers: Config.header,
        //     mode: 'cors',
        //     cache: 'default'
        // }).then(res => res.blob()).then(blob => {
        //     if (blob.type == "application/json") {
        //         var reader = new FileReader();
        //         reader.onload = e => {
        //             var data = JSON.parse(e.target.result);
        //             message.error(data.msg);
        //         }
        //         reader.readAsText(blob);
        //     } else {
        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
        //             window.navigator.msSaveOrOpenBlob(blob, item.name);
        //         } else {// for Non-IE (chrome, firefox etc.)
        //             var a = document.createElement('a');
        //             document.body.appendChild(a);
        //             a.style = 'display: none';
        //             var url = window.URL.createObjectURL(blob);
        //             a.href = url;
        //             a.download = item.name;
        //             a.click();
        //             a.remove();
        //             window.URL.revokeObjectURL(url);
        //         }
        //     }
        // }).catch(err => ({ err }))
    }

    const accept = () => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        Base.callBackApi("studentJob/acceptOffer", jobApplModel).then((data) => {
            if ("SUCCESS" === data?.msg) {
                newMessageRef.current.setIsShow(true)
                newMessageRef.current.setContent("You've successfully accepted the offer for the position of " + jobApplModel.jobTitle + " at " + jobApplModel.companyName)
            } else {
                message.error(data?.msg)
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    const decline = (eventRemark) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        jobApplModel.eventRemark = eventRemark
        Base.callBackApi("studentJob/declinedOffer", jobApplModel).then((data) => {
            if ("SUCCESS" === data?.msg) {
                newMessageRef.current.setIsShow(true)
                newMessageRef.current.setStatusFlag(false)
                newMessageRef.current.setContent("You've successfully declined the offer for the position of " + jobApplModel.jobTitle + " at " + jobApplModel.companyName)
            } else {
                message.error(data?.msg)
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    const request = (eventRemark) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        jobApplModel.eventRemark = eventRemark
        Base.callBackApi("studentJob/requestModification", jobApplModel).then((data) => {
            if ("SUCCESS" === data?.msg) {
                newMessageRef.current.setIsShow(true)
                newMessageRef.current.setContent("You've successfully request modification.")
            } else {
                message.error(data?.msg)
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    const withdrawn = (eventRemark) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        jobApplModel.eventRemark = eventRemark
        Base.callBackApi("studentJob/withdrawn", jobApplModel).then((data) => {
            if ("SUCCESS" === data?.msg) {
                newMessageRef.current.setIsShow(true)
                newMessageRef.current.setStatusFlag(false)
                newMessageRef.current.setContent("You've successfully withdrawn the application for the position of " + jobApplModel.jobTitle + " at " + jobApplModel.companyName)
            } else {
                message.error(data?.msg)
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    const opendialogMessageReason = (param) => {
        MessageReasonRef.current.setContent(param)
        MessageReasonRef.current.setIsShow(true)
    }

    const messageReasonDone = (flag, eventRemark) => {
        if (flag === 'save') {
            withdrawn(eventRemark)
        }
        MessageReasonRef.current.setIsShow(false)
    }

    const openDeclineMessage = (param) => {
        declineMessageRef.current.setContent(param)
        declineMessageRef.current.setIsShow(true)
    }

    const openRequestModal = () => {
        requestMessageRef.current.setContent('To request modification or deletion of your personal data submitted to the Industry Partner through your job application, please enter your message in the provided box below. Your request will be promptly forwarded to the relevant Industry Partner.')
        requestMessageRef.current.setIsShow(true)
    }

    const declineMessageDone = (flag, eventRemark) => {
        if (flag === 'save') {
            decline(eventRemark)
        }
        declineMessageRef.current.setIsShow(false)
    }

    const requestMessageDone = (flag, eventRemark) => {
        if (flag === 'save') {
            request(eventRemark)
        }
        requestMessageRef.current.setIsShow(false)
    }

    const openAttachDocument = () => {
        setIsAttachDocumentModal(true)
    }

    const attachDocument = (flag, documentFileList, description) => {
        if (!flag) {
            setIsAttachDocumentModal(false)
            return
        }
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        let formData = new FormData();
        for (let file of documentFileList) {
            if (file.status != undefined) {
                formData.append('files', file.originFileObj);
            }
        }
        let model = {
            jobApplId: jobApplModel.jobApplId,
            jobId: jobApplModel.jobId,
            lastUpdatedDate: jobApplModel.lastUpdatedDate,
            eventRemark: description,
        }
        formData.append("model", JSON.stringify(model));
        Base.callBackUploadApi("studentJob/attachDocument", formData).then((data) => {
            if ("SUCCESS" === data.msg) {
                setIsAttachDocumentModal(false)
                attachShow()
            } else {
                message.error(data.msg)
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }


    const attach = () => {
        searchById(jobApplId)
        attachMessageRef.current.setIsShow(false)
    }

    const submit = () => {
        searchById(jobApplId)
        submitMessageRef.current.setIsShow(false)
    }

    const attachShow = () => {
        attachMessageRef.current.setContent("You've successfully sent the additional information and/or supplementary documents to the IP.")
        attachMessageRef.current.setIsShow(true)
    }

    const submitShow = () => {
        submitMessageRef.current.setContent("You've successfully submitted your application. Please wait while the employer views your application. ")
        submitMessageRef.current.setIsShow(true)
    }

    const generatePdf = (model) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        fetch(Config.apiDownloadServer + "studentApplyJobDetailPdf/generatePdf", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    console.log(data);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "StudentJobAppliction" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".pdf";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(() => { }).finally(() => setIsLoad(false));


    }

    return (
        <div id="container" className='websiteTemplate studentApplyJobDetail'>
            <NewMessage ref={newMessageRef} done={newMessageDone} />
            <NewMessage ref={attachMessageRef} done={attach} />
            <NewMessage ref={submitMessageRef} done={submit} />
            <MessageRejected ref={MessageReasonRef} done={messageReasonDone} />
            <MessageRejected ref={declineMessageRef} done={declineMessageDone} />
            <MessageRequest ref={requestMessageRef} done={requestMessageDone} />
            {isStdApplyJobModal && <StdApplyJobModal onClose={stdApplyJobClose} jobPostModel={jobApplModel} />}
            {isAttachDocumentModal && <AttachDocumentModal onClose={attachDocument} jobApplModel={jobApplModel} />}
            <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className='detailStatusBox'>
                        <div className="detailTitle">Review Application</div>
                        <div className='specialTipBox'>
                            <div className={'statusTitleBox ' + jobApplModel.jobApplStatus}>{context.jobApplStatusMap.map(item => item.value === jobApplModel.jobApplStatus && item.label)}</div>
                            {jobApplModel.jobApplStatus === 'SPECIAL_ARRANGEMENT' &&
                                <Popover placement="bottom" content={
                                    <div style={{ textAlign: 'justify', hyphens: 'none', maxWidth: '370px', wordBreak: 'break-word' }}>
                                        {'The Module Convener (MC) has granted "special" approval for the Job Post and it is now accessible to students for job search.'}
                                        <br></br>
                                        <br></br>
                                        {'This "special" approval pertains to a specific arrangement for student to submit job applications to the Industry Partner (outside the Digital Platform), as agreed upon beforehand by the Industry Partner and MC.'}
                                    </div>}
                                    trigger="hover" >
                                    <div className='questionTitle'><QuestionCircleOutlined style={{ color: '#000' }} /></div>
                                </Popover>
                            }
                        </div>
                    </div>
                    <div className="websiteSysButtonBox">
                        {
                            (jobApplModel.jobApplStatus === 'REJECTED' || jobApplModel.jobApplStatus === 'DECLINED' || jobApplModel.jobApplStatus === 'STUDENT_WITHDRAWN') && jobApplModel.lastApplyDate >= moment().startOf('day').valueOf() &&
                            <div className='websiteSysButton' onClick={reapply}><img src={submitApplicationImg} />Edit & Resubmit</div>
                        }
                        {
                            jobApplModel.jobApplStatus === 'DRAFT' && jobApplModel.lastApplyDate >= moment().startOf('day').valueOf() &&
                            <div className='websiteSysButton' onClick={reapply}><img src={submitApplicationImg} />Edit to Apply</div>
                        }
                        {
                            jobApplModel.jobApplStatus === 'OFFER' &&
                            <>
                                <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0BBB5C' }} onClick={() => accept()}><img src={approveImg} />Accept</div>
                                <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#D71020' }} onClick={() => openDeclineMessage('Please input the reason for rejecting the offer. The reason will be shared with the industry partner and visible to the module convenor.')}><img src={rejectImg} />Decline</div>
                            </>
                        }
                        {
                            jobApplModel.jobApplStatus === 'REQUEST_DOCUMENT' &&
                            <>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Popover placement="bottom" content={<div>
                                        - Allowed file types: PDF, Word, JPG<br></br>
                                        - File size limit applies<br></br>
                                        - Videos should not be attached<br></br>
                                        - Store videos on a cloud drive (e.g. student&apos;s OneDrive)<br></br>
                                        - Include the video URL in the PDF/Word file or add it as a Web Link attachment.
                                    </div>} trigger="hover" >

                                        <div className='questionCircle' style={{ color: '#000', marginRight: '-10px', alignItems: 'center', display: 'flex' }} ><QuestionCircleOutlined /></div>
                                    </Popover>
                                </div>

                                <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} onClick={openAttachDocument}><img src={attachDocumentImg} />
                                    Provide More Info
                                </div>
                            </>
                        }
                        {/* {
                        (jobApplModel.jobApplStatus === 'REQUEST_DOCUMENT' || jobApplModel.jobApplStatus === 'DOCUMENT_ATTACHED') &&
                        <div className='websiteSysButton' onClick={submitApplication}><img src={submitApplicationImg} />Submit Application</div>
                    } */}
                        {
                            (jobApplModel.jobApplStatus === 'TEACHER_REVIEWING' || jobApplModel.jobApplStatus === 'SPECIAL_ARRANGEMENT'
                                || jobApplModel.jobApplStatus === 'PEND_IP_RECEIPT' || jobApplModel.jobApplStatus === 'REQUEST_DOCUMENT'
                                || jobApplModel.jobApplStatus === 'IP_PROCESSING' || jobApplModel.jobApplStatus === 'DOCUMENT_ATTACHED') &&
                            <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#D71020' }} onClick={() => opendialogMessageReason('Please input the reason for withdrawning the job application. The reason will be shared with the industry partner and visible to the module convenor.')}><img src={DeclineImg} />Withdrawn</div>
                        }
                    </div>
                </div>
                <MessagesTop ref={messageRef} />
                <div className="websiteSysContentBox">
                    <div className='detailPrintButtonTopBox'></div>
                    {(jobApplModel.jobApplStatus === 'PEND_IP_RECEIPT' || jobApplModel.jobApplStatus === 'REQUEST_DOCUMENT' || jobApplModel.jobApplStatus === 'DOCUMENT_ATTACHED' || jobApplModel.jobApplStatus === 'IP_PROCESSING') &&
                        <Button className="websiteSysButton requestButton" onClick={() => openRequestModal()} style={{ color: '#FFFFFF', backgroundColor: '#0059AC', fontSize: '15px' }}>Request Personal Data Modification</Button>}
                    <Button className="websiteSysButton detailPrintButton" onClick={() => generatePdf(jobApplModel)} style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} icon={<PrinterOutlined style={{ fontSize: "18px" }} />}>Print</Button>
                    <div className='websiteSysContent'>
                        {(jobApplModel.jobApplStatus === 'PEND_IP_RECEIPT' || jobApplModel.jobApplStatus === 'REQUEST_DOCUMENT' || jobApplModel.jobApplStatus === 'DOCUMENT_ATTACHED' || jobApplModel.jobApplStatus === 'IP_PROCESSING') && <div className='detailPrintButtonBox'></div>}
                        <div className='contentLogoImgBox'>
                            <img src={jobApplModel.companyLogo ? Config.partnerImg + jobApplModel.companyLogo + '?' + Config.sasToken : CompanyLogo} />
                        </div>
                        <div className='contentTitle'>{jobApplModel.companyName}</div>
                        <div className='flexBox'>
                            <div className='label'>Job ID</div>
                            <div className='value'>{jobApplModel.jobId}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Title
                            </div>
                            <div className='value'>
                                {jobApplModel.jobTitle}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Post Status
                            </div>
                            <div className='value'>
                                {ContextHandler.getMapValue('jobPostStatusMap', jobApplModel.jobPostStatus)}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Post Active Date
                            </div>
                            <div className='value'>
                                {jobApplModel.eventDate ? moment(jobApplModel.eventDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Company Description
                            </div>
                        </div>
                        <div id='companyProfile' className=' valueJustify'>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company Office Address</div>
                            <div className='value'>{jobApplModel.companyLocation}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company Website</div>
                            <div className='value'>
                                <a href={jobApplModel.companyWebsite && !jobApplModel.companyWebsite.startsWith('https://') ? 'https://' + jobApplModel.companyWebsite : jobApplModel.companyWebsite} target="_blank" rel="noreferrer">{jobApplModel.companyWebsite}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company LinkedIn</div>
                            <div className='value'>
                                <a href={jobApplModel.companySocialMedia && !jobApplModel.companySocialMedia.startsWith('https://') ? 'https://' + jobApplModel.companySocialMedia : jobApplModel.companySocialMedia} target="_blank" rel="noreferrer">{jobApplModel.companySocialMedia}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company YouTube</div>
                            <div className='value'>
                                <a href={jobApplModel.companyYouTube && !jobApplModel.companyYouTube.startsWith('https://') ? 'https://' + jobApplModel.companyYouTube : jobApplModel.companyYouTube} target="_blank" rel="noreferrer">{jobApplModel.companyYouTube}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company Instagram</div>
                            <div className='value'>
                                <a href={jobApplModel.companyInstagram && !jobApplModel.companyInstagram.startsWith('https://') ? 'https://' + jobApplModel.companyInstagram : jobApplModel.companyInstagram} target="_blank" rel="noreferrer">{jobApplModel.companyInstagram}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company Facebook</div>
                            <div className='value'>
                                <a href={jobApplModel.companyFacebook && !jobApplModel.companyFacebook.startsWith('https://') ? 'https://' + jobApplModel.companyFacebook : jobApplModel.companyFacebook} target="_blank" rel="noreferrer">{jobApplModel.companyFacebook}</a>
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Company WeChat</div>
                            <div className='value'>
                                {jobApplModel.companyWechat}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Other</div>
                            <div className='value'>
                                {jobApplModel.other}
                            </div>
                        </div>
                        <div className='flexBox marginTop10px'>
                            <div className='label'>
                                Job Description
                            </div>
                        </div>
                        <div id='jobDesc' className=' valueJustify'>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Requirement
                            </div>
                        </div>
                        <div id='jobRequirement' className=' valueJustify'>
                        </div>
                    </div>
                    <div className='contentCenterLine'></div>
                    <div className='websiteSysContent'>
                        <div className='detailPrintButtonBox'>
                            {/* <Button className="websiteSysButton"  onClick={() => generatePdf(jobApplModel)} style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} icon={<PrinterOutlined style={{ fontSize: "18px" }} />}
                        >Print</Button> */}
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Application ID</div>
                            <div className='value'>{jobApplModel.jobApplId}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Designated THEi Programme</div>
                            <div className='value'>
                                {jobApplModel.progTitle}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Job Mode
                            </div>
                            <div className='value'>
                                {jobApplModel.positionTypeVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Employment Type
                            </div>
                            <div className='value'>
                                {jobApplModel.jobTypeVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Salary (HKD)
                            </div>
                            <div className='value'>
                                {jobApplModel.salaryRangeFrom} ~ {jobApplModel.salaryRangeTo}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Salary Basis
                            </div>
                            <div className='value'>
                                {jobApplModel.unitVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Estimated No. of Days a Week
                            </div>
                            <div className='value'>
                                {jobApplModel.estimatedNoOfDaysAWeek}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Estimated No. of Hours a Week
                            </div>
                            <div className='value'>
                                {jobApplModel.estimatedNoOfHoursAWeek}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Work Location
                            </div>
                            <div className='value'>
                                {jobApplModel.workLocVal}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Expected Commence Date
                            </div>
                            <div className='value'>
                                {jobApplModel.expCommenceDate ? moment(jobApplModel.expCommenceDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Expected End Date
                            </div>
                            <div className='value'>
                                {jobApplModel.expEndDate ? moment(jobApplModel.expEndDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>
                                Application Deadline
                            </div>
                            <div className='value'>
                                {jobApplModel.lastApplyDate ? moment(jobApplModel.lastApplyDate).format(Config.dateFormatEn) : ''}
                            </div>
                        </div>
                        <div className='contentLine'></div>
                        <div className='flexBox'>
                            <div className='label'>Student ID</div>
                            <div className='value'>{jobApplModel.studentAcctId}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Student Name</div>
                            <div className='value'>{(jobApplModel.firstName ?? '') + ' ' + (jobApplModel.lastName ?? '')}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Programme Enrolled</div>
                            <div className='value'>{jobApplModel.studentProgTitle}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Email</div>
                            <div className='value'>{jobApplModel.email}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Contact Phone</div>
                            <div className='value'>{jobApplModel.contactPhone}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>WhatsApp</div>
                            <div className='value'>{jobApplModel.whatsApp}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Wechat</div>
                            <div className='value'>{jobApplModel.weChat}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>LinkedIn</div>
                            <div className='value'>{jobApplModel.linkedIn}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Personal Web</div>
                            <a href={(jobApplModel.personalWeb && !jobApplModel.personalWeb.startsWith('https://')) ? 'https://' + jobApplModel.personalWeb : jobApplModel.personalWeb} target="_blank" rel="noreferrer">{jobApplModel.personalWeb}</a>
                        </div>
                        <div className='flexDocumentBox'>
                            <div className='label'>Resume</div>
                            {
                                jobApplModel.annexName && <div className='tag' title={jobApplModel.annexName} onClick={() => downloadFile({ name: jobApplModel.annexName, path: jobApplModel.storagePath }, jobApplModel.resumeType === 'SELECT')}>
                                    <img src={tag1} className="tagImg"></img>{jobApplModel.annexName}
                                </div>
                            }
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Portfolio Link</div>
                            <div className='linkBox'>
                                {jobApplModel.portfolioLinkOne &&
                                    <div className='tag'>
                                        <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkOne && !jobApplModel.portfolioLinkOne.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkOne : jobApplModel.portfolioLinkOne} title={jobApplModel.portfolioLinkOne} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkOneDesc ? jobApplModel.portfolioLinkOneDesc : jobApplModel.portfolioLinkOne}</a>
                                    </div>
                                }
                                {jobApplModel.portfolioLinkTwo &&
                                    <div className='tag'>
                                        <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkTwo && !jobApplModel.portfolioLinkTwo.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkTwo : jobApplModel.portfolioLinkTwo} title={jobApplModel.portfolioLinkTwo} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkTwoDesc ? jobApplModel.portfolioLinkTwoDesc : jobApplModel.portfolioLinkTwo}</a>
                                    </div>
                                }
                                {jobApplModel.portfolioLinkThree &&
                                    <div className='tag'>
                                        <img src={tag2} className="tagImg"></img><a href={(jobApplModel.portfolioLinkThree && !jobApplModel.portfolioLinkThree.startsWith('https://')) ? 'https://' + jobApplModel.portfolioLinkThree : jobApplModel.portfolioLinkThree} title={jobApplModel.portfolioLinkThree} target="_blank" rel="noreferrer">{jobApplModel.portfolioLinkThreeDesc ? jobApplModel.portfolioLinkThreeDesc : jobApplModel.portfolioLinkThree}</a>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Additional Attachment</div>
                        </div>
                        <div className='documentDiv'>
                            {jobApplModel.jobApplAnnexModelList?.map(item =>
                                !item.jobApplEventId && <div className='flexDocumentBox' key={item.jobApplAnnexId}>
                                    <div className='label'>{item.fileTypeVal}</div>
                                    <div className='tag' key={item.jobApplAnnexId} title={item.annexName} onClick={() => downloadFile({ name: item.annexName, path: item.storagePath })}>
                                        <img src={tag1} className="tagImg"></img>{item.annexName}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Additional Comment</div>
                            <div className='valueJustify value2'>{jobApplModel.additionalInfo}</div>
                        </div>
                        <div className='flexBox'></div>
                        {jobApplModel?.eventRequestDocumentList?.map((item, index) =>
                            <div key={index} className='documentRemarkBox'>
                                <div className='flexBox'>
                                    <div className='label'><span style={{ color: '#0059AC', fontWeight: 'bold' }}>{index + 1} </span>IP Request More Info</div>
                                    <div className='valueJustify value2'>{item.eventRemark}</div>
                                </div>
                                {jobApplModel?.eventDocumenAttachedList[index] &&
                                    <>
                                        {jobApplModel?.eventDocumenAttachedList[index]?.eventRemark &&
                                            <div className='flexBox'>
                                                <div className='label'>Additional Information</div>
                                                <div className='valueJustify value2'>{jobApplModel?.eventDocumenAttachedList[index]?.eventRemark}</div>
                                            </div>
                                        }
                                        {
                                            item?.jobApplAnnexModelList?.map((item, i) =>
                                                <div className='flexDocumentBox' key={i}>
                                                    {
                                                        i == 0 ? <div className='label'>Additional Attachment</div> : <div className='label'></div>
                                                    }
                                                    <div className='tag' key={item.jobApplAnnexId} title={item.annexName} onClick={() => downloadFile({ name: item.annexName, path: item.storagePath })}>
                                                        <img src={tag1} className="tagImg"></img>{item.annexName}
                                                    </div>
                                                </div>
                                            )}
                                    </>
                                }
                            </div>
                        )}
                        <div className='flexBox'></div>
                        {jobApplModel?.eventDialogList?.map((item, index) => 
                            !Base.isEmptyObject(item) && <div key={index} className='documentRemarkBox'>
                                <div className='flexBox'>
                                    <div className='label'>Application<span style={{ color: '#0059AC', fontWeight: 'bold' }}> {index + 1} </span>Dialog</div>
                                </div>
                                {item?.studentWithdawnRemark && <div className='flexBox'>
                                    <div className='label'>Withdrawn Job Application Reason</div>
                                    <div className='valueJustify value2'>{item.studentWithdawnRemark}</div>
                                </div>}
                                {item?.specialRemark && <div className='flexBox'>
                                    <div className='label'>Special Arrangement Remark</div>
                                    <div className='valueJustify value2'>{item.specialRemark}</div>
                                </div>}
                                {item?.rejectedRemark && <div className='flexBox'>
                                    <div className='label'>MC Reject Appliction Reason</div>
                                    <div className='valueJustify value2'>{item.rejectedRemark}</div>
                                </div>}
                                {item?.offerEventRemark && <div className='flexBox'>
                                    <div className='label'>IP Make Offer Additional Info</div>
                                    <div className='valueJustify value2'>{item.offerEventRemark}</div>
                                </div>}
                                {item?.offerDeclinedRemark && <div className='flexBox'>
                                    <div className='label'>Offer Rejected Reason</div>
                                    <div className='valueJustify value2'>{item.offerDeclinedRemark}</div>
                                </div>}
                            </div>
                        )}
                    </div>
                </div>
                <div className="websiteSysButtonBox">
                    {
                        (jobApplModel.jobApplStatus === 'REJECTED' || jobApplModel.jobApplStatus === 'DECLINED' || jobApplModel.jobApplStatus === 'STUDENT_WITHDRAWN') && jobApplModel.lastApplyDate >= moment().startOf('day').valueOf() &&
                        <div className='websiteSysButton' onClick={reapply}><img src={submitApplicationImg} />Edit & Resubmit</div>
                    }
                    {
                        jobApplModel.jobApplStatus === 'DRAFT' && jobApplModel.lastApplyDate >= moment().startOf('day').valueOf() &&
                        <div className='websiteSysButton' onClick={reapply}><img src={submitApplicationImg} />Edit to Apply</div>
                    }
                    {
                        jobApplModel.jobApplStatus === 'OFFER' &&
                        <>
                            <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0BBB5C' }} onClick={() => accept()}><img src={approveImg} />Accept</div>
                            <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#D71020' }} onClick={() => openDeclineMessage('Please input the reason for rejecting the offer. The reason will be shared with the industry partner and visible to the module convenor.')}><img src={rejectImg} />Decline</div>
                        </>
                    }
                    {
                        jobApplModel.jobApplStatus === 'REQUEST_DOCUMENT' &&
                        <>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Popover placement="bottom" content={<div>
                                    - Allowed file types: PDF, Word, JPG<br></br>
                                    - File size limit applies<br></br>
                                    - Videos should not be attached<br></br>
                                    - Store videos on a cloud drive (e.g. student&apos;s OneDrive)<br></br>
                                    - Include the video URL in the PDF/Word file or add it as a Web Link attachment.
                                </div>} trigger="hover" >

                                    <div className='questionCircle' style={{ color: '#000', marginRight: '-10px', alignItems: 'center', display: 'flex' }} ><QuestionCircleOutlined /></div>
                                </Popover>
                            </div>

                            <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#0059AC' }} onClick={openAttachDocument}><img src={attachDocumentImg} />
                                Provide More Info
                            </div>
                        </>

                    }

                    {
                        (jobApplModel.jobApplStatus === 'TEACHER_REVIEWING' || jobApplModel.jobApplStatus === 'SPECIAL_ARRANGEMENT'
                            || jobApplModel.jobApplStatus === 'PEND_IP_RECEIPT' || jobApplModel.jobApplStatus === 'REQUEST_DOCUMENT'
                            || jobApplModel.jobApplStatus === 'IP_PROCESSING' || jobApplModel.jobApplStatus === 'DOCUMENT_ATTACHED') &&
                        <div className='websiteSysButton' style={{ color: '#FFFFFF', backgroundColor: '#D71020' }} onClick={() => opendialogMessageReason('Please input the reason for withdrawning the job application. The reason will be shared with the industry partner and visible to the module convenor.')}><img src={DeclineImg} />Withdrawn</div>
                    }
                </div>
            </Spin>
        </div>
    )
}

export default StudentApplyJobDetail;